import React from 'react';
import {
    ChallengePageEntrySupportDto,
    CommunityPageEntrySupportDto,
    TeamSupportDto
} from '@api/ChallengeClient';
import { TenantPageEntrySupportDto } from '@api/TenantClient';
import { ChallengeMultiSelect } from '@components/multi-select/challenge-multi-select';
import { CommunityMultiSelect } from '@components/multi-select/community-multi-select';
import { TeamMultiSelect } from '@components/multi-select/team-multi-select';
import { TenantMultiSelect } from '@components/multi-select/tenant-multi-select';
import { FormSection } from '@components/form-section';

export interface SelectionSectionProps {
    selectedTenants: TenantPageEntrySupportDto[];
    setSelectedTenants: (tenants: TenantPageEntrySupportDto[]) => void;
    selectedCommunities: CommunityPageEntrySupportDto[];
    setSelectedCommunities: (
        communities: CommunityPageEntrySupportDto[]
    ) => void;
    selectedTeams: TeamSupportDto[];
    setSelectedTeams: (teams: TeamSupportDto[]) => void;
    selectedChallenges: ChallengePageEntrySupportDto[];
    setSelectedChallenges: (challenges: ChallengePageEntrySupportDto[]) => void;
}

export const SelectionSection: React.FC<SelectionSectionProps> = ({
    selectedTenants,
    setSelectedTenants,
    selectedCommunities,
    setSelectedCommunities,
    selectedTeams,
    setSelectedTeams,
    selectedChallenges,
    setSelectedChallenges
}) => (
    <FormSection
        title="Selection"
        description="Search and select entries to generate a connection link"
    >
        <div className="flex flex-col gap-4">
            <TenantMultiSelect
                value={selectedTenants}
                onChange={setSelectedTenants}
            />
            <CommunityMultiSelect
                value={selectedCommunities}
                onChange={setSelectedCommunities}
            />
            <TeamMultiSelect
                value={selectedTeams}
                onChange={setSelectedTeams}
            />
            <ChallengeMultiSelect
                value={selectedChallenges}
                onChange={setSelectedChallenges}
            />
        </div>
    </FormSection>
);
